/* istanbul ignore file */
import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';

import { Observable } from 'rxjs';

import { HttpBaseService } from '../../../core';
import { environment } from '../../../environments/environment';
import { PlatformUserGuides } from '../../models/platform-user-guides';

@Injectable({
    providedIn: 'root'
})

export class UserGuideDataService extends HttpBaseService {
    private route = environment.api + 'user-guide';

    constructor(
        private _httpClient: HttpClient
    ) {
        super(_httpClient);
    }

    getUserGuides(): Observable<PlatformUserGuides> {
        const url = this.route;
        return this.httpGet(url);
    }
}
